<template>
  <div>
    <h3 class="font-bold">{{ _(keys.title) }}</h3>
    <div class="my-2">
      {{ _(keys.text) }}
    </div>

    <div class="divide-y divide-solid divide-gray-300 my-4">
      <div v-for="cookie in keys.cookies" :key="cookie.id" class="py-4">
        <div class="grid grid-cols-3 gap-2">
          <div>
            <div class="text-xs text-black text-opacity-40">
              {{ _('cookies.details_table_name') }}
            </div>
            <static-string> {{ cookie.cookie_name }} </static-string>
          </div>
          <div>
            <div class="text-xs text-black text-opacity-40">
              {{ _('cookies.details_table_provider') }}
            </div>
            <static-string>{{ cookie.provider_name }} </static-string>
          </div>
         
          <div>
            <div class="text-xs text-black text-opacity-40">
              {{ _('cookies.details_table_expiry') }}
            </div>
            <div v-if="cookie.expiry !== null">
              {{ cookie.expiry }}
            </div>
          </div>
        </div>
        <div class="text-xs text-black text-opacity-40 mt-2">
          {{ _('cookies.details_table_purpose') }}
        </div>
        <div class="text-sm text-black text-opacity-80">
          <static-string>{{ cookie.purpose }}</static-string>
        </div>
        <div>
          <div class="text-xs text-black text-opacity-40 mt-2">
            {{ _('cookies.details_table_domain_use') }}
          </div>
          <div class="text-sm text-black text-opacity-80">
            <static-string>{{ cookie.provider }}</static-string>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const MAP = {
  necessary: {
    title: 'cookies.necessary.details_title',
    alert: 'cookies.necessary.alert',
    text: 'cookies.necessary.details_text',
    cookies: [
      // this.options.filter(obj => {
      //   return obj.cookie_type === 'performance'
      // })
      // {
      //   name: 'session',
      //   provider: 'Liberties.EU',
      //   expiry: 'cookies.details_table_expiry_session',
      //   purpose: 'cookies.details_table_purpose_session',
      //   domain_use: 'cookies.details_table_domain_use_session'
      // },
      // {
      //   name: 'already_redirected',
      //   provider: 'Liberties.EU',
      //   expiry: 'cookies.details_table_expiry_already_redirected',
      //   purpose: 'cookies.details_table_purpose_already_redirected',
      //   domain_use: 'cookies.details_table_domain_use_already_redirected'
      // },
      // {
      //   name: 'cookies_settings',
      //   provider: 'Liberties.EU',
      //   expiry: 'cookies.details_table_expiry_cookies_consent',
      //   purpose: 'cookies.details_table_purpose_cookies_consent',
      //   domain_use: 'cookies.details_table_domain_use_cookies_consent' 
      // },
      // {
      //   name: 'newsletter_popup',
      //   provider: 'Liberties.EU',
      //   expiry: 'cookies.details_table_expiry_cookies_newsletter_popup',
      //   purpose: 'cookies.details_table_purpose_cookies_newsletter_popup',
      //   domain_use: 'cookies.details_table_domain_use_cookies_newsletter_popup'
      // }
    ]
  },
  preferences: {
    title: 'cookies.preferences.details_title',
    alert: 'cookies.preferences.alert',
    text: 'cookies.preferences.details_text',
    cookies: [
      // {
      //   name: 'Stripe',
      //   provider: 'stripe.com',
      //   expiry: 'cookies.details_table_expiry_stripe',
      //   purpose: 'cookies.details_table_purpose_stripe',
      //   domain_use: 'cookies.details_table_domain_use_stripe' 
      // },
      // {
      //   name: 'PayPal',
      //   provider: 'paypal.com',
      //   expiry: 'cookies.details_table_expiry_paypal',
      //   purpose: 'cookies.details_table_purpose_paypal',
      //   domain_use: 'cookies.details_table_domain_use_paypal'
      // },
      // {
      //   name: 'PayPal',
      //   provider: 'paypal.com',
      //   expiry: 'cookies.details_table_expiry_paypal_sc_f',
      //   purpose: 'cookies.details_table_purpose_paypal_sc_f',
      //   domain_use: 'cookies.details_table_domain_use_paypal'
      // },
      // {
      //   name: 'PayPal',
      //   provider: 'paypal.com',
      //   expiry: 'cookies.details_table_expiry_paypal_KHcl0EuY7AKSMgfvHl7J5E7hPtK',
      //   purpose: 'cookies.details_table_purpose_paypal_KHcl0EuY7AKSMgfvHl7J5E7hPtK',
      //   domain_use: 'cookies.details_table_domain_use_paypal'
      // },
      // {
      //   name: 'PayPal',
      //   provider: 'paypal.com',
      //   expiry: 'cookies.details_table_expiry_paypal_SEGM',
      //   purpose: 'cookies.details_table_purpose_paypal_SEGM',
      //   domain_use: 'cookies.details_table_domain_use_paypal'
      // },
      // {
      //   name: 'PayPal',
      //   provider: 'paypal.com',
      //   expiry: 'cookies.details_table_expiry_paypal_cookie_check',
      //   purpose: 'cookies.details_table_purpose_paypal_cookie_check',
      //   domain_use: 'cookies.details_table_domain_use_paypal'
      // },
      // {
      //   name: 'PayPal',
      //   provider: 'paypal.com',
      //   expiry: 'cookies.details_table_expiry_paypal_d_id',
      //   purpose: 'cookies.details_table_purpose_paypal_d_id',
      //   domain_use: 'cookies.details_table_domain_use_paypal'
      // },
      // {
      //   name: 'PayPal',
      //   provider: 'paypal.com',
      //   expiry: 'cookies.details_table_expiry_paypal_enforce_policy',
      //   purpose: 'cookies.details_table_purpose_paypal_enforce_policy',
      //   domain_use: 'cookies.details_table_domain_use_paypal'
      // },
      // {
      //   name: 'PayPal',
      //   provider: 'paypal.com',
      //   expiry: 'cookies.details_table_expiry_paypal_ts',
      //   purpose: 'cookies.details_table_purpose_paypal_ts',
      //   domain_use: 'cookies.details_table_domain_use_paypal'
      // },
      // {
      //   name: 'PayPal',
      //   provider: 'paypal.com',
      //   expiry: 'cookies.details_table_expiry_paypal_x-pp-s',
      //   purpose: 'cookies.details_table_purpose_paypal_x-pp-s',
      //   domain_use: 'cookies.details_table_domain_use_paypal'
      // },
      // {
      //   name: 'PayPal',
      //   provider: 'paypal.com',
      //   expiry: 'cookies.details_table_expiry_paypal_ts_c',
      //   purpose: 'cookies.details_table_purpose_paypal_ts_c',
      //   domain_use: 'cookies.details_table_domain_use_paypal'
      // },
      // {
      //   name: 'PayPal',
      //   provider: 'stats.paypal.com',
      //   expiry: 'cookies.details_table_expiry_paypal_c',
      //   purpose: 'cookies.details_table_purpose_paypal_c',
      //   domain_use: 'cookies.details_table_domain_use_paypal_c'
      // },
      // {
      //   name: 'PayPal',
      //   provider: 'stats.paypal.com',
      //   expiry: 'cookies.details_table_expiry_paypal_nsid',
      //   purpose: 'cookies.details_table_purpose_paypal_nsid',
      //   domain_use: 'cookies.details_table_domain_use_paypal'
      // }
    ]
  },
  performance: {
    title: 'cookies.performance.details_title',
    alert: 'cookies.performance.alert',
    text: 'cookies.performance.details_text',
    cookies: [
      // {
      //   name: 'Matomo Analytics On-Premise',
      //   provider: 'matomo.com',
      //   expiry: 'cookies.details_table_expiry_matomo',
      //   purpose: 'cookies.details_table_purpose_matomo',
      //   domain_use: 'cookies.details_table_domain_use_matomo'
      // },
      // {
      //   name: 'Matomo Analytics On-Premise',
      //   provider: 'matomo.com',
      //   expiry: 'cookies.details_table_expiry_matomo_pk_id',
      //   purpose: 'cookies.details_table_purpose_matomo_pk_id',
      //   domain_use: 'cookies.details_table_domain_use_matomo'
      // },
      // {
      //   name: 'Matomo Analytics On-Premise',
      //   provider: 'matomo.com',
      //   expiry: 'cookies.details_table_expiry_matomo_pk_ses',
      //   purpose: 'cookies.details_table_purpose_matomo_pk_ses',
      //   domain_use: 'cookies.details_table_domain_use_matomo'
      // },
      // {
      //   name: 'Matomo Analytics On-Premise',
      //   provider: 'matomo.com',
      //   expiry: 'cookies.details_table_expiry_matomo_pk_testcookie',
      //   purpose: 'cookies.details_table_purpose_matomo_pk_testcookie',
      //   domain_use: 'cookies.details_table_domain_use_matomo'
      // },
      // {
      //   name: 'Matomo Analytics On-Premise',
      //   provider: 'matomo.com',
      //   expiry: 'cookies.details_table_expiry_matomo_pk_hsr',
      //   purpose: 'cookies.details_table_purpose_matomo_pk_hsr',
      //   domain_use: 'cookies.details_table_domain_use_matomo'
      // },
      // {
      //   name: 'Matomo Analytics On-Premise',
      //   provider: 'matomo.com',
      //   expiry: 'cookies.details_table_expiry_matomo_pk_ref',
      //   purpose: 'cookies.details_table_purpose_matomo_pk_ref',
      //   domain_use: 'cookies.details_table_domain_use_matomo'
      // },
      // {
      //   name: 'Matomo Analytics On-Premise',
      //   provider: 'matomo.com',
      //   expiry: 'cookies.details_table_expiry_matomo_pk_cvar',
      //   purpose: 'cookies.details_table_purpose_matomo_pk_cvar',
      //   domain_use: 'cookies.details_table_domain_use_matomo'
      // }
    ]
  },
  functional_preferences: {
    title: 'cookies.functional_preferences.details_title',
    alert: 'cookies.functional_preferences.alert',
    text: 'cookies.functional_preferences.details_text',
    cookies: [
      // {
      //   name: 'Issuu',
      //   provider: 'issuu.com',
      //   expiry: 'cookies.details_table_expiry_issuu',
      //   purpose: 'cookies.details_table_purpose_issuu',
      //   domain_use: 'cookies.details_table_domain_use_issuu'
      // },
      // {
      //   name: 'Interact',
      //   provider: 'tryinteract.com',
      //   expiry: 'cookies.details_table_expiry_interact',
      //   purpose: 'cookies.details_table_purpose_interact',
      //   domain_use: 'cookies.details_table_domain_use_interact'
      // },
      // {
      //   name: 'Facebook',
      //   provider: 'facebook.com',
      //   expiry: 'cookies.details_table_expiry_facebook',
      //   purpose: 'cookies.details_table_purpose_facebook',
      //   domain_use: 'cookies.details_table_domain_use_facebook'
      // },
      // {
      //   name: 'Facebook',
      //   provider: 'facebook.com',
      //   expiry: 'cookies.details_table_expiry_facebook_datr',
      //   purpose: 'cookies.details_table_purpose_facebook_datr',
      //   domain_use: 'cookies.details_table_domain_use_facebook'
      // },
      // {
      //   name: 'Facebook',
      //   provider: 'facebook.com',
      //   expiry: 'cookies.details_table_expiry_facebook_dpr',
      //   purpose: 'cookies.details_table_purpose_facebook_dpr',
      //   domain_use: 'cookies.details_table_domain_use_facebook'
      // },
      // {
      //   name: 'Facebook',
      //   provider: 'facebook.com',
      //   expiry: 'cookies.details_table_expiry_facebook_m_pixel_ratio',
      //   purpose: 'cookies.details_table_purpose_facebook_m_pixel_ratio',
      //   domain_use: 'cookies.details_table_domain_use_facebook'
      // },
      // {
      //   name: 'Facebook',
      //   provider: 'facebook.com',
      //   expiry: 'cookies.details_table_expiry_facebook_sb',
      //   purpose: 'cookies.details_table_purpose_facebook_sb',
      //   domain_use: 'cookies.details_table_domain_use_facebook'
      // },
      // {
      //   name: 'Facebook',
      //   provider: 'facebook.com',
      //   expiry: 'cookies.details_table_expiry_facebook_usida',
      //   purpose: 'cookies.details_table_purpose_facebook_usida',
      //   domain_use: 'cookies.details_table_domain_use_facebook'
      // },
      // {
      //   name: 'Facebook',
      //   provider: 'facebook.com',
      //   expiry: 'cookies.details_table_expiry_facebook_wd',
      //   purpose: 'cookies.details_table_purpose_facebook_wd',
      //   domain_use: 'cookies.details_table_domain_use_facebook'
      // },
      // {
      //   name: 'Flourish',
      //   provider: 'flourish.studio',
      //   expiry: 'cookies.details_table_expiry_flourish',
      //   purpose: 'cookies.details_table_purpose_flourish',
      //   domain_use: 'cookies.details_table_domain_use_flourish'
      // },
      // {
      //   name: 'Youtube',
      //   provider: 'youtube.com',
      //   expiry: 'cookies.details_table_expiry_youtube',
      //   purpose: 'cookies.details_table_purpose_youtube',
      //   domain_use: 'cookies.details_table_domain_use_youtube'
      // }
    ]
  }
};

export default {
  props: {
    data: Object,
    details: String,
    options: Array
  },

  computed: {
    keys() {
      MAP[this.details].cookies = this.options.filter(cookie => {
        return cookie.cookie_type == this.details;
      });

      return MAP[this.details];
    }
  },
 
  methods: {
    _(key) {
      return this.data[key];
    }
  }
};
</script>

<style></style>
